import { Alert, Button, IconButton, Stack } from '@mui/material';
import Layout from "../../../Frames/Layout";
import { Link, useSearchParams } from 'react-router-dom';
import { Add, Close } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import SessionsTable from './SessionsTable';
import API from '../../../../services/API';

export default function Index(){

    const [searchParams, setSearchParams] = useSearchParams();
    const actionId = searchParams.get('actionId');
    const [action, setAction] = useState(null);

    useEffect(() => {
        if (!actionId) {
            setAction(null);
            return;
        }

        API.get(`/dpc/actions/${actionId}`)
            .then(r => setAction(r.data))
            .catch(() => setAction(null));
    }, [actionId]);

    const newSessionPath = actionId
        ? `/dpc/actions/${actionId}/sessions/new`
        : `/dpc/actions/0/sessions/new`;

    return (
        <Layout title="Sessions DPC" tab="sessions" menu="dpc">
            <Stack direction="row" flexWrap="wrap" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                {actionId &&
                    <Alert
                        severity={action ? 'info' : 'warning'}
                        action={
                            <IconButton size="small" onClick={() => setSearchParams({})}>
                                <Close />
                            </IconButton>
                        }
                        sx={{ flex: 1 }}
                    >
                        {action
                            ? <>Filtré sur l'action <b>{actionId}</b> — {action.title}</>
                            : <>Filtré sur l'action <b>{actionId}</b></>
                        }
                    </Alert>
                }

                <Button
                    startIcon={<Add />}
                    component={Link}
                    to={newSessionPath}
                >
                    Session
                </Button>
            </Stack>

            <SessionsTable actionId={actionId} />
        </Layout>
    );
}
